import React, {useState, useEffect} from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {normalizeUSDate, normalizeDate, calculate_age} from '../functions';
import { Tooltip as ReactTooltip } from "react-tooltip";
import axios from "axios";
import {get_golfer_memberships, getGolferMemberships, updatePaymentMethod} from '../../API/APICalls';
import {States} from '../../data/States'
import {
  useStripe,
  useElements,
  CardNumberElement, 
  CardCvcElement, 
  CardExpiryElement
} from "@stripe/react-stripe-js";

export default function MembershipPayments() {

    const navigate = useNavigate();
   
    const location = useLocation();
    let contact_guid = location.state.contact_guid;

    let dealid=location.state.dealId;



    const stripe = useStripe();
    const elements = useElements();
    const [isAutoRenew, setisAutoRenew] = useState(true);
    const [disabled, setDisabled] = useState<boolean>(true);
    const [disabledExpiry, setDisabledExpiry] = useState<boolean>(true);
    const [disabledCvc, setDisabledCvc] = useState<boolean>(true);
    const [usgaTerms, setUsgaTerms] = useState<boolean>(true);
    const [agaTerms, setAgaTerms] = useState<boolean>(true);
    const [message, setMessage] = useState('');
    let agaTermsCheckbox = document.getElementById("agaTerms");
    const [data, setData] = useState<[]>([]);
    const [isBack, setIsBack] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [pagepanel, setPagePanel] = useState("collapse show");
    const [alert, setAlert] = useState('ms-2 alert alert-danger');

    const [inputs, setInputs] = useState({firstname: location.state.membership.firstname, lastname: location.state.membership.lastname, phone: location.state.membership.phone, email: location.state.membership.email, dob: '', sex: '', address: location.state.membership.address, address2:  location.state.membership.address2, city: location.state.membership.city, state:location.state.membership.state, zip: location.state.membership.zip, contact: '', credit_card_brand: '', credit_card_expiry: '', credit_card_expiry_year: '', last4:'', stripe_customer: location.state.membership.stripe_customer_token, stripe_payment_token: location.state.membership.stripe_payment_method_token, stripe_subscription_token: location.state.membership.stripe_subscription_token});
   
    const handleChange = ({ target: { name, value } }: { target: { name: string, value: string } }) => setInputs(inputs => ({ ...inputs, [name]: value }));

    const handleElementChange = async (event:any)  => {

      //console.log(event);

      if (event.elementType=="cardNumber" && event.complete == false) {
       //   setMessage("INCORRECT");
          setDisabled(true);
      }  else {
          setMessage("");
          setDisabled(false);
      }
  }

  const handleElementExpiryChange = async (event:any)  => {
      if (event.elementType=="cardExpiry" && event.complete == false) {
         // setExpiryMessage("INCORRECT");
          setDisabledExpiry(true);
      }  else {
          setMessage('');
          setDisabledExpiry(false);
      }
  }

  const handleElementCvcChange = async (event:any)  => {
      if (event.elementType=="cardCvc" && event.complete == false) {
          //setDisabled(true);
          setDisabledCvc(true);
      }  else {
          setMessage('');
          //setDisabled(false);
          setDisabledCvc(false);
      }
  }


  
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setIsLoading(true);

    const payElement = elements?.getElement(CardNumberElement);
    const payElementExp = elements?.getElement(CardExpiryElement);
    const payElementCVC = elements?.getElement(CardCvcElement);



    if (!payElement ||  !stripe) {
        return;
        }

    const result = await stripe.createPaymentMethod({
        type: "card",
        card: payElement,
        "billing_details": {
            "address": {
                "city": inputs.city,
                "country": "US",
                "line1": inputs.address,
                "line2": inputs.address2,
                "postal_code": inputs.zip,
                "state": inputs.state
                },
                "email": inputs.email,
                "name": inputs.firstname + " " + inputs.lastname,
                "phone": inputs.phone
        }
        });

        //console.log(result)
        
         //call stripe api to update API       
         const response = await updatePaymentMethod(inputs.stripe_customer, result, inputs.stripe_subscription_token, dealid);
        // console.log(response);

         if (("error" in JSON.parse(response || '')))
         //if (JSON.parse(response || '')?.error?.message !== "")  
        {
            
                setMessage(JSON.parse(response || '').error.message);
                setIsLoading(false);
                return false;
        } else {
            setAlert('ms-2 alert alert-success');
            setMessage("Your have successfully updated your default payment method. Please check your email for confirmation.");

            setPagePanel("collapse hide");
            setIsLoading(false);
        }
    }


    const toggleBack = () => {
        setIsBack(!isBack);
    };



  function formatDateAndAddDays(date:any, daysToAdd:any) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + daysToAdd);
  
    const dd = newDate.getDate().toString().padStart(2, '0');
    const mm = date.toLocaleString('default', { month: 'long' });
    const yyyy = newDate.getFullYear();
  
    return `${mm}, ${dd} ${yyyy}`;
  }

    const today = new Date();
    const formattedDate = formatDateAndAddDays(today, 365);

    const handleAutoRewnewSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
      //event.preventDefault();
      setisAutoRenew(!isAutoRenew);
  }




  //const [users, setUsers] = useState([]);

useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
        try {
          const response = await getGolferMemberships(contact_guid, dealid); // Replace with your Node.js API endpoint
          //console.log(response);
        
          setData(JSON.parse(response || '').results);
          setIsLoading(false);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
    
    fetchData();
    
},[])



     const options = {
      showIcon: true,
      disableLink: true,
      style: {
        base: {
          fontSize: "16px",
          color: "#424770",
          "::placeholder": {
            color: "#aab7c4"
          },
          "::focus": { 
            color: "#424770"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      }
  } 

    return(
    <div className="container page_container mb-5 pb-5">
       { pagepanel === "collapse show" ? 
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-10 mx-auto">
       
       
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 my-5 ">
            <h1 className="fs-1 text-left">Update Payment and Billing Info</h1>
        </div>  

        {isLoading ? 
            <div className="loaderWrapper">
              <div className="loader"></div>
              
            </div>
            : ''}
        

        <div className="col-12 mb-5">
            <div className="col-12 col-sm-12 mb-1">
            {data.map((results, key) => (
                <div className='row col-12' key={key}>
                    
                    <div className="col-9">
                        <h4>Default Payment Method</h4>
                        <div className="col-12">Credit Card <span>{results['properties']['credit_card_brand']} ({results['properties']['last_4']})</span></div>
                        <div className="col-12">Exp <span>{results['properties']['credit_card_expiry']+"/"+results['properties']['credit_card_expiry_year']}</span></div>
                        <div className="col-12">
                        {data.map((results, key) => (
                            <div className="col-12mb-3" key={key}>
                                Your membership automatically renews on {normalizeUSDate(results['properties']['expiration_date'])}.
                            </div>
                        ))}
                        </div>
                    </div>
                    <div className="col-3 pt-4 text-end">
                        <a className="btn btn-primary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample" onClick={toggleBack}>
                            Edit Payment
                        </a>
                        
                    </div>
                    
                </div>
            ))}
            <hr />
            {isBack ?
            
            <Link to="/membership/dashboard"  state={{"contact_guid":location.state.contact_guid, "handicap_id": location.state.handicap_id}}  className="w-100 btn btn-outline-secondary btn-lg rounded-pill" type="button">
                                  BACK
                              </Link>
            : '' }
        </div>



        <form onSubmit={handleSubmit}>
    
    
        <div className="col-12 mb-5 collapse" id="collapseExample">
            <div className="col-12 col-sm-12 mb-1">
  
                <div className='row pt-2'>
                <h2>Credit Card Details</h2>  
                    <div className="col-8 col-sm-6 col-md-7 col-lg-7 col-xxl-7">
                        <label className='pb-2'>Credit Card Number</label>
                        <CardNumberElement className="border rounded p-2" id="card_number form-control" options={options} onChange={handleElementChange} />
                       
                    </div>
                    <div className='col-3 col-sm-3 col-md-3 col-lg-4 col-xxl-4'>
                        <span id="creditcards"><img src='../../assests/cards/accepted_cards.png' className='img img-fluid'/></span>
                    </div>
                </div>
            </div>

                <div className='row'>
                    <div className="col-12 col-sm-6 col-xs-12 mt-3">
                        <label className='pb-2'>Expiration Date</label>
                        <CardExpiryElement className="border rounded p-2" id="card_exp card-element" options={options} onChange={handleElementExpiryChange}/>   
                    </div>
                    
                    <div className="col-12 col-sm-6 col-md-5 mt-3">
                        <label className='pb-2'>Verification Code (CVC)</label>
                        <CardCvcElement className="border rounded p-2" id="card_cvc card-element" options={options} onChange={handleElementCvcChange} />   
                    </div>
                    
                </div>

                <hr className="my-5" />
                {data.map((results, key) => (
                <div className="row col-sm-12 col-12 col-md-12 col-lg-12 col-xl-10 col-xxl-12" key={key}> 
                    <h2>Billing Address Information</h2>      
                <div className="col-12 col-sm-12 col-md-12">
                      <label className="form-label">Street Address*</label>
                      <input type="text" className="form-control" id="address" name="address" placeholder="" autoFocus value={inputs.address || results['properties']['address'] || ''}  onChange={handleChange} required/>
                  </div>

                  <div className="col-sm-12 col-sm-12 col-12 col-md-12 col-lg-12 mt-4">
                      <label className="form-label">Address 2</label>
                      <input type="text" className="form-control" id="address2" name="address2" placeholder="" value={inputs.address2 || results['properties']['address2'] || ''} onChange={handleChange} />  
                  </div>

                  <div className="col-sm-12 col-sm-12 col-12 col-md-12 col-lg-12 mt-4">
                      <label className="form-label">City*</label>
                      <input type="text" className="form-control" id="city" placeholder="" name="city" value={inputs.city || results['properties']['city'] || ''} onChange={handleChange} required/>
                      
                  </div>
                  
                      <div className="col-sm-6 col-sm-6 col-6 col-md-6 col-lg-6 mt-4">
                          <label className="form-label">State</label>
                          <select name="state" className="form-select" id="state" onChange={handleChange} value={inputs.state || results['properties']['state']} disabled={true}>             
                                  <option value="">Please select state</option>
                                  {States.map((option, index) =>(
                                  <option value={option.value} key={index}>{option.label}</option>
                                  ))}
                              </select>                        
                      </div>

                      <div className="col-sm-6 col-6 col-md-6 col-lg-6 mt-4">
                              <label className="form-label">ZIP Code</label>
                              <input type="text" className="form-control" id="zipcode" placeholder="" name="zip" value={inputs.zip || results['properties']['zip'] || ''} onChange={handleChange} disabled={true}/>
                              
                          </div>
                
                  </div>
                ))}

                <div className='row my-4'>
                {message && <div id="payment-message" className='text-danger'>{message}</div>}
                </div>

        
        
        <div className="row mt-4 col-12 col-md-12 col-sm-12 col-lg-12">
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 order-1 pt-3">
                              <Link to="/membership/dashboard"  state={{"contact_guid":location.state.contact_guid, "handicap_id": location.state.handicap_id}}  className="w-100 btn btn-outline-secondary btn-lg rounded-pill" type="button">
                                  BACK
                              </Link>
                          </div>
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 order-sm-1 order-lg-1 pt-3 ms-0">
                              <button className="btn btn-primary w-100 btn-lg rounded-pill" type="submit" disabled={disabled || disabledExpiry || disabledCvc}>
                              {/* <button className="btn btn-primary w-100 btn-lg rounded-pill" type="submit"> */}
                                  CONTINUE
                              </button>
                          </div>
                      </div>

                    </div>
                      </form>
                       
       </div>
       </div>
       :<>       <div className="row col-10 py-5 mx-auto text-center">
                    <div className={alert} role="alert">
                    {message}
                    </div>
                    <div className="fs-5">Thank you!</div>
                    <div className="fs-5">If you have any questions about your refund, please email <a href="mailto:gcsupport@usga.org">gcsupport@usga.org</a>.</div>
                    <div className="row">
                            <div className="col-12 col-sm-10 col-md-10 mx-auto pt-3">
                                <Link to="/membership/dashboard" state={{"contact_guid": location.state.contact_guid, "handicap_id": location.state.handicap_id}} className="w-100 btn btn-outline-primary btn-lg rounded-pill px-5 " type="button">
                                    Manage Memberships
                                </Link>
                            </div>

                    </div>
                </div>
                    
                </>
            }
    </div>
    )
}